export default __webpack_public_path__ + "static/TSD_Wrapping_Featured-118f54b3eb7dcae6e07cf132f0a16f97.jpg";